var _path, _rect, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBannerline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 426,
    viewBox: "0 0 229 426",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.48859C185.5 -18.5119 211.672 125 211 143.988C205.5 299.488 78.5 423.488 78.5 423.488",
    stroke: "#004E4C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10 12"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40.6846,
    height: 58,
    transform: "translate(188 95)",
    fill: "#FFF8EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.027 113.585C218.14 111.652 215.343 111.096 213.13 111.617C211.448 112.014 210.117 113.021 209.538 114.391C208.945 115.794 209.042 117.719 210.811 119.945C212.078 121.539 212.236 123.725 211.209 125.306C210.519 126.37 209.291 127.118 207.568 127.276C204.61 127.548 202.829 124.807 202.429 121.587C201.745 116.096 205.178 109 214.821 108.451C216.242 108.37 217.126 108.062 217.595 107.748C218.106 107.41 218.367 106.991 218.491 106.583C218.634 106.105 218.609 105.588 218.337 105.057C218.087 104.567 217.478 103.949 216.47 103.447C211.973 101.202 197.673 99.806 193.048 113.228C190.617 120.286 192.724 126.987 196.21 132.475C201.248 140.407 209.127 145.733 209.127 145.733C209.764 146.165 210.622 146.064 211.142 145.497C214.865 141.447 220.971 134.828 223.147 128.005C224.724 123.062 224.348 118.012 220.027 113.585Z",
    fill: "#004E4C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerline);
export default __webpack_public_path__ + "static/media/bannerline.baaaeedb906f41cc66d61bfb72a0b0b6.svg";
export { ForwardRef as ReactComponent };